// removed by extract-text-webpack-plugin
module.exports = {"panel":"rank_rec_36y09j2","item":"rank_rec_1bGS-JU","rank":"rank_rec_19y0SCE","gold":"rank_rec_3I_D-8l","silver":"rank_rec_qk6UNIm","copper":"rank_rec_3nxb8Fr","normal":"rank_rec_2jsmJmH","book":"rank_rec_2BdWsT2"};


//////////////////
// WEBPACK FOOTER
// ./src/component/rec/rank_rec.css
// module id = 838
// module chunks = 0